var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prowerSetting"},[_c('prowerSelect',_vm._g(_vm._b({attrs:{"linkbreak":_vm.linkbreak}},'prowerSelect',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }